import { orderBy, filter, keys } from 'lodash';

function addActivityToGroup(activity, container) {
  const result = container;
  if (result[activity.actionType]) {
    result[activity.actionType].push(activity);
  } else {
    result[activity.actionType] = [activity];
  }
  return result;
}
export default function parseGetPlanActivitiesSuccess(data, oldState) {
  const state = oldState;
  // parse data from backend
  state.planActivity = [];
  // all possible activities
  // ADD_COURSE = 'add_course'
  // REMOVE_COURSE = 'remove_course'
  // ADD_PATHWAY = 'add_pathway'
  // REMOVE_PATHWAY = 'remove_pathway'
  // CHANGE_GRAD_PLAN = 'change_grad_plan'
  // SUBMIT_PLAN = 'submit_plan'
  // APPROVE_PLAN = 'approve_plan'
  // DENY_PLAN = 'deny_plan'
  // SUBMIT_OVERRIDE = 'submit_override'
  let groupContainer = {};
  // const testData = [
  //   {
  //     modifier: 'Guardians of Ben Garfield',
  //     timestamp: 1534587780.851144,
  //     template:
  //       '{modifier_name} did not approve the graduation plan for the following reasons: {deny_note}.',
  //     data: {
  //       deny_note:
  //         'I thought Ben was going to tak the accounting career pathway?!',
  //     },
  //     actionType: 'deny_plan',
  //   },
  //   {
  //     modifier: 'Ben Garfield',
  //     timestamp: 1524587780.851144,
  //     template: '{modifier_name} approved the graduation plan.',
  //     data: null,
  //     actionType: 'approve_plan',
  //   },
  //   {
  //     modifier: 'Samantha Lee',
  //     timestamp: 1514187780.851144,
  //     template: '{modifier_name} submitted the graduation plan for review.',
  //     data: null,
  //     actionType: 'submit_plan',
  //   },
  //   {
  //     modifier: 'Samantha Lee',
  //     timestamp: 1514187780.851144,
  //     template:
  //       '{modifier_name} changed the graduation plan from {old_grad_plan_name} to {new_grad_plan_name}.',
  //     data: {
  //       old_grad_plan_name: 'Standard Diploma',
  //       new_grad_plan_name: 'Advanced Diploma',
  //     },
  //     actionType: 'change_grad_plan',
  //   },
  //   {
  //     modifier: 'Samantha Lee',
  //     timestamp: 1514187780.851144,
  //     template: '{modifier_name} removed the {pathway_name} pathway.',
  //     data: { pathway_name: 'Mobile Game Tester' },
  //     actionType: 'remove_pathway',
  //   },
  //   {
  //     modifier: 'Samantha Lee',
  //     timestamp: 1514187780.851144,
  //     template: '{modifier_name} added the {pathway_name} pathway.',
  //     data: { pathway_name: 'Fine Arts - Art' },
  //     actionType: 'add_pathway',
  //   },
  //   {
  //     modifier: 'Samantha Lee',
  //     timestamp: 1514187780.851144,
  //     template:
  //       '{modifier_name} removed the following courses: {course_names}.',
  //     data: {
  //       course_names: ['Oceanography - 4551', 'Earth Science - 4320'],
  //     },
  //     actionType: 'remove_course',
  //   },
  //   {
  //     modifier: 'Samantha Lee',
  //     timestamp: 1514187780.851144,
  //     template: '{modifier_name} added the following courses: {course_names}.',
  //     data: {
  //       course_names: ['Biology - 4370', 'AP Biology - 4380'],
  //     },
  //     actionType: 'add_course',
  //   },
  //   {
  //     modifier: 'Samantha Lee',
  //     timestamp: 1514187780.851144,
  //     template: '{modifier_name} issued overrides for: {exception_message}.',
  //     data: {
  //       exception_message:
  //         'You need to choose courses that satisfy the Chemistry or Physics requirements.',
  //     },
  //     actionType: 'submit_override',
  //   },
  //   {
  //     modifier: 'Ben Garfield',
  //     timestamp: 1514187780.851144,
  //     template: '{modifier_name} submitted the graduation plan for review.',
  //     data: null,
  //     actionType: 'submit_plan',
  //   },
  // ];

  // group by submit_plan, approve_plan, deny_plan
  data.forEach((activity, index) => {
    if (
      ['approve_plan', 'deny_plan', 'submit_plan'].indexOf(
        activity.actionType,
      ) !== -1
    ) {
      if (groupContainer.submit_plan) {
        // there's already previous submit_plan in the current groupContainer, will insert the new group and create new group here
        groupContainer.timestamp = groupContainer.submit_plan[0].timestamp;
        state.planActivity.push(groupContainer);
        groupContainer = {};
      }
      groupContainer = addActivityToGroup(activity, groupContainer);
      if (['approve_plan', 'deny_plan'].indexOf(activity.actionType) !== -1) {
        groupContainer.timestamp = activity.timestamp;
        state.planActivity.push(groupContainer);
        groupContainer = {};
      }
    } else {
      groupContainer = addActivityToGroup(activity, groupContainer);
    }
    if (index === data.length - 1) {
      if (!groupContainer.timestamp) {
        groupContainer.timestamp = activity.timestamp;
      }
      state.planActivity.push(groupContainer);
    }
  });
  state.planActivity = orderBy(
    filter(state.planActivity, group => keys(group).length > 1),
    ['timestamp'],
    ['desc'],
  );
  return state;
}
